import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=648ad534&"
import script from "./Song.vue?vue&type=script&lang=js&"
export * from "./Song.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports